import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TrendingUp } from 'angular-feather/icons';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReportFile } from '../models/reportFile';
import { ReportFleet } from '../models/reportFleet';
import { extractFileNameAndBlob } from 'src/app/core/helpers/downloadFIle.helper';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}

  requestOptionsReportLastPosition: Object = {
    headers: new HttpHeaders()
      .set('Content-Type', 'text/plain; charset=utf-8')
      .set(
        'x-api-key',
        'a3J9Ap1xuBF59qovcDLv6hsveI6yY7cnQoaeMH0o8UIoix3eylYDXSNqPm4lhOWctI5ORCbWSTCiOVfTdHqpw3GJbPByy5s1dQsDiEy1rBLpAJcG2I5Ip6gReailAs8q'
      ),
    responseType: 'text',
    withCredentials: true,
  };
  headers = new HttpHeaders().set('Content-Type', 'application/octet-stream');
  requestOptionsSummarizedPosition: Object = {
    headers: this.headers,
    responseType: 'arraybuffer',
    observe: 'response',
    withCredentials: true,
  };

  requestOptionsReportFleet: Object = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    observe: 'events',
  };

  requestOptionsFilter: Object = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    responseType: 'json',
  };

  public requestFleet(): Observable<any> {
    return this.http.get<any>(
      `${this.apiServerUrl}/report/requestFleet`,
      this.requestOptionsReportFleet
    );
  }

  public requestFleetFilter(): Observable<any> {
    return this.http.get<any>(
      `${this.apiServerUrl}/report/requestFleetFilter`,
      this.requestOptionsFilter
    );
  }

  public getListFiles(fileTypeId: number): Observable<ReportFile[]> {
    return this.http.get<ReportFile[]>(
      `${this.apiServerUrl}/report/request/${fileTypeId}`
    );
  }

  public getReportFiles(fileTypeId: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiServerUrl}/report/requestFile/${fileTypeId}`,
      this.requestOptionsReportLastPosition
    );
  }

  // public requestReportFiles(fileTypeId: number, userEmail: string) {
  //   let userEmailFormat = userEmail.replace('@', 'zxx').split('.').join('xxz');
  //   window.open(
  //     this.apiServerUrl +
  //       `/report/downloadReportFile/${fileTypeId}/${userEmailFormat}`
  //   );
  // }

  public requestReportFile(
    fileTypeId: number,
    userEmail: string
  ): Observable<any> {
    return this.http.post<any>(
      this.apiServerUrl + `/report/downloadReportFile`,
      { email: userEmail, fileTypeId: fileTypeId },
      // { withCredentials: true }
      this.requestOptionsReportLastPosition
    );
  }

  public downloadReportFilesOpen(fileName: string) {
    window.open(
      this.apiServerUrl + `/report/downloadReportFileOpen/${fileName}`
    );
  }

  // public async requestReportFilesAsync(
  //   fileTypeId: number,
  //   userEmail: string
  // ): Promise<Observable<any>> {
  //   let userEmailFormat = userEmail.replace('@', 'zxx').split('.').join('xxz');

  //   return await this.http
  //     .get(
  //       this.apiServerUrl +
  //         `/report/downloadReportFile/${fileTypeId}/${userEmailFormat}`,
  //       {
  //         responseType: 'arraybuffer',
  //       }
  //     )
  //     .pipe(
  //       map((httpResponse: any) => {
  //         return httpResponse;
  //       })
  //     )
  //     .toPromise();
  // }

  /*
   *** SummarizedPositions
   */

  public getReportSummarizedPositions(): Observable<any> {
    return this.http.get<any>(
      `${this.apiServerUrl}/report/requestSummarizedPositionsList`
    );
  }

  public getReportSummarizedPositionsFileUrl(
    fileName: string
  ): Observable<any> {
    return this.http
      .post<any>(
        `${this.apiServerUrl}/report/requestSummarizedPositionsFile`,
        fileName,
        this.requestOptionsSummarizedPosition
      )
      .pipe(
        map((httpResponse: HttpResponse<ArrayBuffer>) =>
          extractFileNameAndBlob(httpResponse)
        )
      );
  }
  public getReportSummarizedPositionsSerialSearch(item: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/report/requestSummarizedPositionsSerialList`,
      item
    );
  }
}
